// MSA webview方法

/**
 * 调用MAS的 webview方法
 * @param {*} funcName 方法名称
 * @param  {...any} params 方法参数
 * @returns 方法返回值|undefined
 * eg: msaJsFunc('onClose')
 *
 * 支持的方法
 * 折叠: onHide
 * 关闭webview: onClose
 * 域名白名单: canResolveUri(uri)  参数是逗号分隔的字符串
 * 打开浏览器: callBrowser(String url)  参数：url
 * 判断是否是横屏: isLandscape()
 * 是否跳转浏览器: isCallExternalBrowser 返回值：true跳转/false不跳转
 */
export function msaJsFunc(funcName, ...params) {
  if (!process.client) return
  if (window.RIBridge && window.RIBridge[funcName]) {
    return window.RIBridge[funcName](...params)
  }
}

// 判断是否是MSA的webview
export function isMsaWebView() {
  if (!process.client) return
  return !!window.RIBridge
}

/**
 * 客户端根据内存判断是否跳转浏览器
 * 如果需要跳转，会直接跳转到浏览器，并返回true
 * 如果不需要跳转，返回false
 * @param {*} url 跳转地址
 * @returns true跳转/false不跳转
 */
export function jumpBrowser(url) {
  if (isMsaWebView() && msaJsFunc('isCallExternalBrowser')) {
    msaJsFunc('callBrowser', url)
    return true
  }
  return false
}
